import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import StarField from '../components/StarField';
import styles from './Intro.module.css';

export default function Intro() {
  const { dispatch } = useApp();
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 300),
      setTimeout(() => setPhase(2), 1200),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  const handleEnter = () => {
    if (phase < 2) return; // 等动画出现后才能跳过
    setPhase(3);
    setTimeout(() => dispatch({ type: 'SET_PAGE', payload: 'consent' }), 1000);
  };

  return (
    <div 
      className={`${styles.container} ${phase >= 3 ? styles.fadeOut : ''}`}
      onClick={handleEnter}
    >
      <StarField density={150} speed={0.3} />
      
      {/* 文字图片 - 在山脉中间 */}
      <div className={`${styles.textContainer} ${phase >= 2 ? styles.visible : ''}`}>
        <img src="/images/yihangzi.png" alt="" className={styles.textImg} />
      </div>

      {/* 山脉背景图 */}
      <div className={`${styles.mountains} ${phase >= 1 ? styles.visible : ''}`}>
        <img src="/images/intro-bg.png" alt="" />
      </div>
    </div>
  );
}
